import { NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule, Routes } from '@angular/router';
import { AreYouSureGuard } from '@app/core/are-you-sure-guard/are-you-sure.guard';
import { EditReservationAgreementComponent } from '@app/modules/guest-experience/pages/edit-reservation-agreement/edit-reservation-agreement.component';
import { InboxAiOverviewComponent } from '@app/modules/guest-experience/pages/inbox-ai-overview/inbox-ai-overview.component';
import { InboxAiSettingsComponent } from '@app/modules/guest-experience/pages/inbox-ai-settings/inbox-ai-settings.component';
import { ReservationAgreementsComponent } from '@app/modules/guest-experience/pages/reservation-agreements/reservation-agreements.component';
import { CannedResponseDetailComponent } from './pages/canned-response-detail/canned-response-detail.component';
import { CannedResponsesComponent } from './pages/canned-responses/canned-responses.component';
import { CustomCodeDetailComponent } from './pages/custom-code-detail/custom-code-detail.component';
import { CustomCodesComponent } from './pages/custom-codes/custom-codes.component';
import { LogDetailComponent } from './pages/log-detail/log-detail.component';
import { LogComponent } from './pages/log/log.component';
import { OverviewComponent } from './pages/overview/overview.component';
import { QuestionDetailComponent } from './pages/question-detail/question-detail.component';
import { QuestionsComponent } from './pages/questions/questions.component';
import { ReviewDetailComponent } from './pages/review-detail/review-detail.component';
import { ReviewsComponent } from './pages/reviews/reviews.component';
import { RuleDetailComponent } from './pages/rule-detail/rule-detail.component';
import { RulesComponent } from './pages/rules/rules.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'overview',
    pathMatch: 'full',
  },
  {
    path: 'upsells',
    loadChildren: () => import('../product-catalog/product-catalog.module').then((m) => m.ProductCatalogModule),
  },
  {
    path: 'overview',
    component: OverviewComponent,
    data: {
      identifier: 'gx-overview',
    },
  },
  {
    path: 'rules',
    component: RulesComponent,
    data: {
      identifier: 'gx-messaging-rules',
    },
  },
  {
    path: 'rules/segments/:id',
    component: RulesComponent,
    data: {
      identifier: 'gx-messaging-rules',
      shouldReuse: false,
    },
  },
  {
    path: 'rule/:id',
    component: RuleDetailComponent,
    data: {
      identifier: 'gx-messaging-rule-detail',
      shouldReuse: false,
    },
  },
  {
    path: 'custom-codes',
    component: CustomCodesComponent,
    data: {
      identifier: 'gx-custom-codes',
    },
  },
  {
    path: 'custom-codes/code/:id',
    component: CustomCodeDetailComponent,
    data: {
      identifier: 'gx-custom-code-detail',
      shouldReuse: false,
    },
  },
  {
    path: 'reviews',
    component: ReviewsComponent,
    data: {
      identifier: 'gx-reviews',
    },
  },
  {
    path: 'reviews/review/:id',
    component: ReviewDetailComponent,
    data: {
      identifier: 'gx-review-detail',
      shouldReuse: false,
    },
  },
  {
    path: 'questions',
    component: QuestionsComponent,
    data: {
      identifier: 'gx-questions',
    },
  },
  {
    path: 'questions/intent/:id',
    component: QuestionDetailComponent,
    data: {
      identifier: 'gx-question-detail',
      shouldReuse: false,
    },
  },
  {
    path: 'canned-responses',
    component: CannedResponsesComponent,
    data: {
      identifier: 'gx-canned-responses',
    },
  },
  {
    path: 'canned-responses/resp/:id',
    component: CannedResponseDetailComponent,
    data: {
      identifier: 'gx-canned-response-detail',
      shouldReuse: false,
    },
  },
  {
    path: 'log/:type',
    component: LogComponent,
    data: {
      identifier: 'gx-logs',
      shouldReuse: false,
    },
  },
  {
    path: 'log/:type/:uuid',
    component: LogDetailComponent,
    canDeactivate: [AreYouSureGuard],
    data: {
      identifier: 'gx-log-detail',
      shouldReuse: false,
    },
  },
  {
    path: 'log',
    redirectTo: 'log/events',
  },
  {
    path: 'rental-agreements',
    component: ReservationAgreementsComponent,
    data: {
      title: 'Rental Agreements',
    },
  },
  {
    path: 'rental-agreements/new',
    component: EditReservationAgreementComponent,
    data: {
      title: 'Edit Rental Agreement',
    },
  },
  {
    path: 'rental-agreements/:id',
    component: EditReservationAgreementComponent,
    canDeactivate: [AreYouSureGuard],
    data: {
      title: 'Edit Rental Agreement',
      shouldReuse: false,
    },
  },
  {
    path: 'inbox-ai',
    component: InboxAiOverviewComponent,
    data: {
      identifier: 'gx-inbox-ai',
    },
  },
  {
    path: 'inbox-ai/settings/:groupId',
    component: InboxAiSettingsComponent,
    canDeactivate: [AreYouSureGuard],
    data: {
      identifier: 'gx-inbox-ai-settings',
    },
    resolve: {
      groupId: (route: ActivatedRouteSnapshot) => route.paramMap.get('groupId')
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GuestExperienceRoutingModule {}
